import { createTypes, async, asyncActionCreator } from 'redux-action-creator';
import { getTravelerProfile } from '../../../service/travelerProfileService';
import { ThunkAction } from '../../types';

export const types = createTypes([...async('FETCH')], 'TRAVELER_PROFILE');

type FetchAgentTravelerProfileRequest = {
  includeHealthAlerts: boolean;
  travelerKey: string;
};

export const fetchTravelerProfile = asyncActionCreator(
  types.FETCH,
  {
    action: (includeHealthAlerts: boolean) => getTravelerProfile(includeHealthAlerts),
  },
);

export const fetchAgentTravelerProfile = asyncActionCreator(
  types.FETCH,
  {
    action: ({ includeHealthAlerts, travelerKey }: FetchAgentTravelerProfileRequest) =>
      getTravelerProfile(includeHealthAlerts, travelerKey),
  },
);